export function challengeFirstName(name) {
	if (!name?.trim()) return null;
	return name.trim().split(/\s+/)[0];
}

export function formatNameList(names) {
	const cleaned = names.map((name) => name?.trim()).filter(Boolean);
	if (cleaned.length === 0) return null;
	if (cleaned.length === 1) return cleaned[0];
	if (cleaned.length === 2) return `${cleaned[0]} and ${cleaned[1]}`;
	return `${cleaned.slice(0, -1).join(', ')}, and ${cleaned[cleaned.length - 1]}`;
}

export function buildMutualSupportLine(partnerName) {
	if (!partnerName?.trim()) return null;
	const name = challengeFirstName(partnerName) || partnerName.trim();
	return `${name} is doing this challenge as well.`;
}

export function formatChallengeSummaryDate(iso) {
	if (!iso) return '';
	const parsed = new Date(iso.includes('T') ? iso : `${iso}T12:00:00`);
	if (Number.isNaN(parsed.getTime())) return iso;
	return parsed.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
}

export function challengeDurationDays(startsOn, endsOn) {
	if (!startsOn || !endsOn) return 1;
	const start = new Date(`${startsOn}T12:00:00`);
	const end = new Date(`${endsOn}T12:00:00`);
	if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 1;
	const diff = Math.round((end.getTime() - start.getTime()) / 86400000) + 1;
	return Math.max(1, diff);
}

/** Human label for common preset lengths (7 = 1 week, 30 = 1 month). */
export function challengeDurationLabel(days) {
	if (days === 1) return '1-day';
	if (days === 7) return '1-week';
	if (days === 14) return '2-week';
	if (days === 21) return '3-week';
	if (days === 30) return '1-month';
	if (days === 60) return '2-month';
	if (days === 90) return '3-month';
	return `${days}-day`;
}

export function buildChallengeScheduleLine(startsOn, endsOn) {
	if (!startsOn || !endsOn) return null;

	const days = challengeDurationDays(startsOn, endsOn);
	const sameDay = startsOn === endsOn;
	const lengthLabel = challengeDurationLabel(days);

	if (sameDay) {
		return `This is a 1-day challenge on ${formatChallengeSummaryDate(startsOn)}.`;
	}

	return `This is a ${lengthLabel} challenge that starts on ${formatChallengeSummaryDate(
		startsOn
	)} and ends on ${formatChallengeSummaryDate(endsOn)}.`;
}

export function getChallengeParticipantNames(challenge) {
	if (!challenge) {
		return { challengerName: null, challengedName: null, isSelfChallenge: false };
	}

	if (challenge.kind === 'household' || challenge.kind === 'linked') {
		const challengerName = challenge.challenger_profile?.name;
		const challengedName = challenge.challenged_profile?.name;
		const isSelfChallenge =
			challengerName &&
			challengedName &&
			challengerName.trim().toLowerCase() === challengedName.trim().toLowerCase();

		return { challengerName, challengedName, isSelfChallenge };
	}

	const challengerName =
		challenge.challenger?.first_name || challenge.challenger?.full_name || null;
	const challengedName =
		challenge.challenged?.first_name || challenge.challenged?.full_name || null;
	const isSelfChallenge =
		challenge.challenger?.id != null && challenge.challenger.id === challenge.challenged?.id;

	return {
		challengerName: isSelfChallenge ? challengerName : challengerName,
		challengedName: isSelfChallenge ? challengerName : challengedName,
		isSelfChallenge
	};
}
